// extracted by mini-css-extract-plugin
export var checkoutRateBadge = "_ue-0";
export var checkoutRateBadgeLink = "_ue-1";